import { useEffect, useMemo, useState } from 'react'
import { onValue, ref } from 'firebase/database'
import { db } from '../firebase'
import { useAuth } from '../contexts/AuthContext'
import { buildPlanFromSources } from '../utils/subscriptionPlan'

export const useUserRealtimeData = () => {
  const { user } = useAuth()
  const [profile, setProfile] = useState(null)
  const [billing, setBilling] = useState(null)
  const [loading, setLoading] = useState(Boolean(user))
  const [error, setError] = useState(null)

  const plan = useMemo(
    () => buildPlanFromSources({ userNode: profile, billing }),
    [profile, billing]
  )

  useEffect(() => {
    if (!user?.uid) {
      setProfile(null)
      setBilling(null)
      setLoading(false)
      setError(null)
      return
    }

    setLoading(true)
    setError(null)

    const unsubscribers = []

    const profileRef = ref(db, `users/${user.uid}`)
    unsubscribers.push(
      onValue(
        profileRef,
        (snap) => {
          setProfile(snap.val() || null)
          setLoading(false)
        },
        (err) => {
          setError(err)
          setLoading(false)
        }
      )
    )

    // Cobrança Asaas (opcional); o plano efetivo vem de users/{uid}/profile/subscriptionPlan
    const billingRef = ref(db, `planos/${user.uid}`)
    unsubscribers.push(
      onValue(
        billingRef,
        (snap) => setBilling(snap.val() || null),
        (err) => setError(err)
      )
    )

    return () => {
      unsubscribers.forEach((u) => u?.())
    }
  }, [user?.uid])

  return { profile, plan, loading, error }
}
